import { useEffect } from "react";
import { DEVICE_RESOLUTION } from "../../../app-constants";
import { useAppDispatch } from "../../hooks";
import { setIsMobile } from "./slice";

const DeviceProvider = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const handleResize = () => {
      dispatch(
        setIsMobile(window.innerWidth >= DEVICE_RESOLUTION.MobileMin && window.innerWidth < DEVICE_RESOLUTION.Laptop)
      );
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return children;
};

export default DeviceProvider;
